import React from 'react';
import PubSub from 'pubsub-js';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import Animate from 'rc-animate';
import { TopNavigator, GlobalHeader } from './components';
import { MenuService, UserService } from '~/services';
import AtualizarCadastroView from '~/pages/general/AtualizarCadastroView.jsx';
import './Header.less';

let pageHome = false;

class Header extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
      showAtualizarCadastro: false,
    };
  }

  static getDerivedStateFromProps({ settings }, { isVisible }) {
    if (!settings.autoHideHeader && !isVisible) {
      return { isVisible: true };
    }

    return null;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleSubscription = subscribe => {
    let { token } = this.state;

    if (subscribe) {
      token = PubSub.subscribe('logout_service', () => {
        this.onLogout();
      });
    } else {
      PubSub.unsubscribe(token);
    }
  };

  onLogout = () => {
    const { history } = this.props;

    UserService.logout(() => history.push(`/login`));
  };

  handleScroll = () => {
    const { settings } = this.props;

    if (!settings.autoHideHeader) {
      return;
    }

    const { isVisible, isTicking, oldScrollTop } = this.state;
    const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;

    if (!isTicking) {
      this.setState({ isTicking: true });

      requestAnimationFrame(() => {
        if (oldScrollTop > scrollTop) {
          this.setState({ isVisible: true });
        } else if (scrollTop > 300 && isVisible) {
          this.setState({ isVisible: false });
        } else if (scrollTop < 300 && !isVisible) {
          this.setState({ isVisible: true });
        }

        this.setState({ isTicking: false, oldScrollTop: scrollTop });
      });
    }
  };

  getHeaderWidth = () => {
    const { settings, general } = this.props;

    if (general.isMobile || !settings.fixedHeader || settings.layout === 'topmenu') {
      return '100%';
    }

    return general.isCollapsed ? 'calc(100% - 80px)' : 'calc(100% - 256px)';
  };

  render() {
    const { settings, general } = this.props;
    const { isVisible, showAtualizarCadastro } = this.state;

    setTimeout(() => {
      if (!pageHome) {
        pageHome = true;
        MenuService.open(MenuService.getById('1'));
      }
    }, 500);

    return (
      <>
        <AtualizarCadastroView action={showAtualizarCadastro} onOk={() => this.setState({ showAtualizarCadastro: false })} />
        <Animate component="" transitionName="fade">
          {isVisible ? (
            <Layout.Header
              style={{ padding: 0, zIndex: 2, width: this.getHeaderWidth() }}
              className={settings.fixedHeader ? 'header-fixed-header' : 'no-header-fixed-header'}
            >
              {settings.layout === 'topmenu' && !general.isMobile ? <TopNavigator /> : <GlobalHeader />}
            </Layout.Header>
          ) : null}
        </Animate>
      </>
    );
  }
}

const mapStateToProps = ({ settings, general, menus }) => ({ settings, general, menus });

export default connect(mapStateToProps)(Header);
